<template>
  <div class="main-container-l main-container-dark-bg">
    <div class="verifyticket-page-container">
        <div class="loading-container" v-if="betslipLoading">
            <img src="../../assets/img/loading.svg">
        </div>
        <template v-else>
            <h5>{{ $t('VERIFYTICKET')}}</h5>
            <p>{{ $t('VERIFYTICKETINSTRUCTIONS')}}</p>
            <div class="verify-ticket">
                <div class="input-box">
                    <label>{{ $t('TICKETCODE')}}</label>
                    <input class="input-text"
                    @keyup.enter="getTicket"
                    v-model="ticketCode"
                    v-bind:placeholder="$t('VERIFYTICKETINPUT')" type="text"
                    ref="verifyticketinput">
                </div>
                <div class="verify-ticket-buttons">
                    <!--a class="button button-grey-first button-cancel"
                    @click="$router.go(-1)">
                        {{$t('CANCEL')}}
                    </a-->
                    <a class="button button-blue" @click.stop="getTicket">
                        {{$t('VERIFY')}}
                    </a>
                </div>
                <qrcode-stream @decode="onDecode"></qrcode-stream>
            </div>
        </template>
    </div>
  </div>
</template>

<script>
import {
    mapActions,
    mapGetters,
} from 'vuex';

import { QrcodeStream } from 'vue-qrcode-reader';

export default {
    name: 'VerifyTicket',
    components: {
        QrcodeStream,
    },
    data()
    {
        return {
            ticketCode: '',
        };
    },
    created()
    {
        const me = this;

        me.$nextTick(() =>
        {
            if (me.$refs.verifyticketinput)
            {
                me.$refs.verifyticketinput.focus();
            }
        });
    },
    computed:
    {
        ...mapGetters([
            'betslipLoading',
        ]),
    },
    methods:
    {
        ...mapActions([
            'getTicketData',
        ]),
        async getTicket()
        {
            const me = this;

            await me.fetchTicketData({
                ticketCode: me.ticketCode.toUpperCase().trim(),
            });
        },
        async onDecode(code)
        {
            const me = this;
            if (code.indexOf('*') !== -1)
            {
                await me.fetchTicketData({
                    ticketCode: code.split('*')[0],
                    controlCode: code.split('*')[1],
                });
            }
        },
        async fetchTicketData(params = {})
        {
            await this.getTicketData(params);
        },
    },
    watch:
    {
        ticketData(val)
        {
            const me = this;

            if (val != null
            && !val.error
            && val.data)
            {
                me.ticketCode = '';
            }
        },
    },
};
</script>
